import React from "react";
import { Link } from "react-scroll";
import { VscGitCommit, VscError, VscWarning, VscBell, VscCheck } from "react-icons/vsc";

const Footer = () => {
  return (
    <footer className="sticky bottom-0 z-30 border-t border-editor-border bg-editor-elevated/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-full items-center gap-4 overflow-x-auto px-3 py-1.5 text-[0.7rem] text-syntax-comment">
        <Link
          to="home"
          smooth
          duration={500}
          className="flex cursor-pointer items-center gap-1.5 rounded bg-syntax-fn/15 px-2 py-0.5 text-syntax-fn hover:bg-syntax-fn/25"
        >
          <VscGitCommit /> main
        </Link>
        <span className="flex items-center gap-1"><VscError size={12} /> 0</span>
        <span className="flex items-center gap-1"><VscWarning size={12} /> 0</span>
        <span className="hidden items-center gap-1 text-term-green sm:flex">
          <VscCheck size={12} /> build passing
        </span>

        <span className="ml-auto hidden whitespace-nowrap sm:inline">
          © {new Date().getFullYear()} Khubayb Kapila
        </span>
        <span className="hidden whitespace-nowrap md:inline">UTF-8</span>
        <span className="hidden whitespace-nowrap md:inline">React + Tailwind</span>
        <VscBell size={12} className="flex-shrink-0" />
      </div>
    </footer>
  );
};

export default Footer;
